// SPDX-License-Identifier: LicenseRef-Pachamama-Proprietary
// Copyright 2026 Pachamama Studios B.V. All rights reserved.

/**
 * AYNI — streams held back until we have the right to stream them (owner,
 * 2026-10-06: "Nothing that we don't have the right to stream is
 * shipped"). A held stream is dropped when the live index is read, so it
 * is never listed, searched or played, and a lesson step that names it
 * shows as unavailable.
 *
 * Keyed by the index row's stable `name`. A stream leaves this list only
 * when the source rights register (the Plus plan Claude Doc, tab "Source
 * rights register"; `docs/AYNI_XR_INDIVIDUAL_PLAN.md`) records it as
 * cleared, and joins it by the owner's decision. Checked 2026-10-06, and
 * against the media rights audit of 2026-10-17
 * (`docs/AYNI_XR_MEDIA_RIGHTS_AUDIT.md`):
 * - gfw_traffic: Global Fishing Watch, CC BY-NC 4.0. Held from 2026-10-17;
 *   off the list since 2026-10-20 and played by Education plans only, as
 *   fishing effort is: GFW wrote on 8 October 2026 that educational use
 *   needs no commercial licence (Leah Buckley; register, "Conversations").
 * - geocolor: off the list since 2026-10-17 by the owner's decision, an
 *   accepted risk: CIRA SLIDER publishes no reuse licence; under-1 h Meteosat
 *   frames need a paid EUMETSAT licence.
 * - modis: no longer in the live index (audit, 2026-10-17); held when this
 *   branch was parked, so not on the list.
 * - fires_geostationary: Himawari-derived detections; in every plan by the
 *   owner's decision of 2026-10-18.
 * - gfw_fishing_effort: CC BY-NC, found by the audit; not held but played by
 *   Education plans only (owner, 2026-10-18; `EDUCATION_ONLY_STREAMS` in
 *   xrPlans.ts).
 * - mann2009_temp_recon_yearly: held 2026-10-06 (no licence recorded); off the
 *   list since 2026-10-13: Dr. Mann's written permission of 12 October 2026
 *   (register, "Conversations").
 */
export const RIGHTS_HOLD: ReadonlySet<string> = new Set<string>([])

/** Whether a stream, by its index `name`, is held back for rights. */
export function isRightsHeld(name: string | undefined | null): boolean {
  return typeof name === 'string' && RIGHTS_HOLD.has(name)
}
